import { Form, Formik } from "formik";
import ListHeaderComponent from "../../../components/OB/ListHeaderComponent";
import FormControl from "@mui/material/FormControl";
import { InputLabel, MenuItem, Select, TextField, CircularProgress } from "@mui/material";
import SearchComponent from "../../../components/OB/SearchComponent";
import TableComponent from "../../../components/OB/TableComponent";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { useContext, useEffect, useState } from "react";
import { showToast } from "../../../helpers/ToastifyHelper";
import TahsilatBilgileriListeAPI from "../../../apis/OB/Get/TahsilatBilgileriListeAPI";
import { useNavigate } from "react-router";
import SessionStorageService from "../../../services/StorageService";
import TableComponent2 from "../../../components/OB/TableComponent2";
import TahsilatRaporAPI from "../../../apis/OB/Rapor/TahsilatRaporAPI";
import { openFileInNewTab } from "../../../helpers/openFileNewTab";
import { today, year } from "../../../helpers/TodayDate";
import OdemeBilgileriPopUp from "../../../components/OB/popups/OdemeBilgileriPopUp";
import TahsilatBilgileriGetApi from "../../../apis/OB/Get/TahsilatBilgileriGetApi";
import { ConstantAPISContext } from "../../../context/ConstantAPISContext";
import EBordroAPI from "../../../apis/OB/Get/EBordroAPI";
import BordroAPI from "../../../apis/OB/Rapor/BordroAPI";
 
 
 
const EBordro: React.FC = () => {
    //Input UseStateleri
    const { yilListe } = useContext(ConstantAPISContext);
 
    const [ilkTarih, setIlkTarih] = useState<any>(null);
    const [sonTarih, setSonTarih] = useState<any>(null);
    const [makbuzNo, setMakbuzNo] = useState<any>(null);
    const [searchControl, setSearchControl] = useState<boolean>(true);
    const [requestControl, setRequestControl] = useState<boolean>(false);
    const [selectedAy, setSelectedAy] = useState<any>(undefined);
    const [selectedYear, setSelectedYear] = useState(Number(year));
    const [isSearched, setIsSearched] = useState<boolean>(false);
    const [isLoading, setisLoading] = useState<boolean>(false);
 
    const columns = [
        { header: "", field: "", className: "text-center", beyan: 6, classNameDiv: "" },
        { header: "Bordro Ayı", field: "bordroAyi", className: "text-center", },
        { header: "Kadro Türü", field: "kadroTuru", className: "text-center" },
        { header: "Açıklama", field: "aciklama", className: "text-center" },
        { header: "Bordro Türü", field: "bordroTuru", className: "text-center" },
        { header: "Bordro Tipi", field: "bordroTipi", className: "text-center" },
        { header: "Brüt Tutar", field: "brutTutar", className: "text-center" },
        { header: "Özel Kesinti", field: "ozelKesinti", className: "text-center" },
        { header: "Yasal Kesinti", field: "yasalKesinti", className: "text-center" },
        { header: "Toplam Kesinti", field: "toplamKesinti", className: "text-center" },
        { header: "Net Ödenen", field: "netOdenen", className: "text-center" },
    ];
    //Aylar
    const months = [
        { key: 1, value: 1, label: 'Ocak' },
        { key: 2, value: 2, label: 'Şubat' },
        { key: 3, value: 3, label: 'Mart' },
        { key: 4, value: 4, label: 'Nisan' },
        { key: 5, value: 5, label: 'Mayıs' },
        { key: 6, value: 6, label: 'Haziran' },
        { key: 7, value: 7, label: 'Temmuz' },
        { key: 8, value: 8, label: 'Ağustos' },
        { key: 9, value: 9, label: 'Eylül' },
        { key: 10, value: 10, label: 'Ekim' },
        { key: 11, value: 11, label: 'Kasım' },
        { key: 12, value: 12, label: 'Aralık' }
    ];
    //Pop up
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const openPopup = () => {
        isPopupVisible == true ?
            setIsPopupVisible(false) :
            setIsPopupVisible(true);
    };
    //print Rapor
    const printRapor = (sqId: string, kadroTuruId: any) => {
 
        BordroAPI.geExportPdfListe(sqId, kadroTuruId)
            .then((res) => {
                if (res.data !== null) {
                    openFileInNewTab(
                        res.data.reportUrlByteFormat,
                        "-BORDRO BİLGİLERİ - " + today + ".pdf"
                    );
                } else {
                    showToast("Pdf indirilirken bir hata oluştu tekrar deneyiniz.", "error");
                }
 
            })
            .catch((err) => {
                showToast("Pdf indirilirken bir hata oluştu tekrar deneyiniz.", "error");
            })
    }
 
    //Kullanıcı Login control ve yönlendirme
    const navigate = useNavigate();
    let user = SessionStorageService.getUserInfo();
    const closeUserControlPopup = () => {
        //setUserControlPopup(false);        
        navigate("/login");
    }
    useEffect(() => {
        if (user == null || !((user.rol == "PERSONEL") || (user.rol == "ADMIN"))) {
            //setUserControlPopup(true);
        } else {
 
        }
    }, []);
 
    //EBordro API
    const fetchData = async () => {
 
        const ay = selectedAy === 0 ? undefined : selectedAy;
        setisLoading(true);
        EBordroAPI.getEBordroListe(Number(user.tcKimlikNo),selectedYear, selectedAy)
            .then((res) => {
                setData(res.data);
                setTimeout(() => {
                    setisLoading(false);
 
                }, 100)
                setSearchControl(true)
                setIsSearched(true)
                /*  if (res.data.length < 1)
                     showToast("Kayıt Bulunamadı!", "warning"); */
            })
            .catch((err) => {
                setSearchControl(false)
                showToast("Beklenmedik bir hata oluştu", "error")
            })
    };
    const [data, setData] = useState<any[]>([]);
    const [tarifeGetData, setTarifeGetData] = useState<any[]>([]);
 
    //Temizleme fonksiyonu
    const handleTemizle = () => {
        setIlkTarih(null);
        setSonTarih(null);
        setMakbuzNo(null);
    }
    //Formik constantları
    const initialValues = {
        //boş kalacak ihtiyaca göre kullanılabilir
    };
    return (
 
        <div className="card w-100">
            <div className="px-4 pt-2 card-body">
                <Formik
                    initialValues={initialValues}
                    onSubmit={() => { }}>
                    <Form id="kayit-form" className="d-flex w-100 mb-4">
                        <div className="d-flex flex-column flex-sm-row w-100 gap-3 ml-2 mr-2">
                            <div className="d-flex flex-column flex-sm-row gap-2 w-100">
                                <FormControl size="small"
                                    sx={{
                                        width: {
                                            xs: "100%",
                                            sm: "50%",
                                            md: "25%",
                                        },
                                        minWidth: 140
                                    }}>
 
                                    <InputLabel id="">Yıl</InputLabel>
                                    <Select
                                        sx={{
                                            backgroundColor: "white"
                                        }}
                                        labelId=""
                                        id=""
                                        name="yil"
                                        label="yil"
                                        error={selectedYear == undefined && searchControl == false ? true : false}
                                        value={selectedYear || ""}
                                        onChange={(e) => {
                                            setSelectedYear(Number(e.target.value || undefined));
                                        }}                                >
                                        {yilListe.map((item) => (
                                            <MenuItem
                                                key={item}
                                                value={item.yili}                                            >
                                                {item.yili}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl size="small"
                                    sx={{
                                        width: {
                                            xs: "100%",
                                            sm: "50%",
                                            md: "25%",
                                        },
                                        minWidth: 140
                                    }}>
 
                                    <InputLabel id="">Ay</InputLabel>
                                    <Select
                                        sx={{
                                            backgroundColor: "white"
                                        }}
                                        labelId=""
                                        id=""
                                        name="ay"
                                        label="ay"
                                        error={selectedAy == undefined && searchControl == false ? true : false}
                                        value={selectedAy || ""}
                                        onChange={(e) => {
                                            setSelectedAy(Number(e.target.value || undefined));
                                        }}>
                                        <MenuItem key={""} value={""}>Ay</MenuItem>
                                        {months.map(month => (
                                            <MenuItem key={month.key} value={month.value}>
                                                {month.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="d-flex  flex-row ms-auto ">
                                <SearchComponent
                                    fetchData={fetchData}
                                    onTemizle={handleTemizle}
                                    setData={setData} />
                            </div>
                        </div>
                    </Form>
                </Formik>
                {isLoading ?
                    <div className="d-flex w-100 justify-content-center align-items-center" style={{ height: '10rem' }}>
 
                        <CircularProgress />
                    </div>
                    :
                    <TableComponent2 columns={columns} data={data} recordsPerPage={10} printRaporBordro={printRapor} isSearched={isSearched}></TableComponent2>
                }
            </div >
        </div>
 
    )
}
export default EBordro;